






























import { Component, Prop, Vue } from 'vue-property-decorator';

import { mapState } from "vuex";
import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';

@Component({
  components: { ChevronRightSolid },

  computed: {
    ...mapState([
      'iframeMode',
    ]),
  },
})
export default class Breadcrumb extends Vue {
  @Prop(Array) items: [];
  @Prop(Boolean) isLoading: false;

  /*
    Returns this.items that aren't active to create breadcrumb links in the
    right order
  */
  get breadcrumbLinks () {
    return this.items.filter((i: { path: string, name: string, isActive?: boolean }) => !i.isActive);
  }

  /* Return the active link, that will have custom style in the template */
  get activeLink () {
    return this.items.find((i: { path: string, name: string, isActive?: boolean }) => i.isActive);
  }
}
